import { render, staticRenderFns } from "./menu-break.vue?vue&type=template&id=d8b84b2c&"
import script from "./menu-break.vue?vue&type=script&lang=js&"
export * from "./menu-break.vue?vue&type=script&lang=js&"
import style0 from "./menu-break.vue?vue&type=style&index=0&id=d8b84b2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports